<ng-container *ngIf="useMaterial; else nativeInput">
	<mat-form-field [appearance]="appearance" class="non-negative-number-input__field mat-input-helper">
		<mat-label *ngIf="labelKey">{{ labelKey | translate }}</mat-label>
		<input
			matInput
			type="text"
			inputmode="numeric"
			pattern="[0-9]*"
			[attr.maxlength]="maxlength || null"
			[placeholder]="placeholderKey ? (placeholderKey | translate) : ''"
			[value]="displayValue"
			[disabled]="isDisabled"
			(input)="onInput($event)"
			(blur)="onBlur()"
			(keydown)="onKeydown($event)"
			(paste)="onPaste($event)"
		/>
		<span *ngIf="suffixKey" class="font-input-content color-neutral-grey-01">{{ suffixKey | translate }}</span>
	</mat-form-field>
</ng-container>

<ng-template #nativeInput>
	<input
		class="non-negative-number-input__native"
		[class.error]="hasError"
		type="text"
		inputmode="numeric"
		pattern="[0-9]*"
		[attr.maxlength]="maxlength || null"
		[placeholder]="placeholderKey ? (placeholderKey | translate) : ''"
		[value]="displayValue"
		[disabled]="isDisabled"
		(input)="onInput($event)"
		(blur)="onBlur()"
		(keydown)="onKeydown($event)"
		(paste)="onPaste($event)"
	/>
</ng-template>
